<template>
    <section class="buttons">
        <p>
            <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam</router-link>
            <input type="submit"
                   :class="['btn']"
                   :value="submitText"
                   @click.prevent.stop="emitSubmitForm()">
        </p>
    </section>
</template>

<script>
	export default {
		name: "FormButtons",
		props: {
			moduleName: String,
			customSubmitText: String,
		},
		computed: {
			submitText() {
				if (this.customSubmitText) {
					return this.customSubmitText
				}
				return this.$gettext('Uložit')
			},
		},
		methods: {
			emitSubmitForm(redirect = false) {
				this.$emit('submit-form', redirect)
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/common/FormButtons.vue